import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DateService } from '../../date.service';
import { InfoboxService } from '../../infobox/infobox.service';
import { MapDialogComponent } from '../map-dialog/map-dialog.component';

@Component({
	selector: 'app-map-timetable',
	templateUrl: './map-timetable.component.html',
	styleUrls: ['./map-timetable.component.css'],
})
export class MapTimetableComponent {
	@Input() citiesConnections: Array<any> = [];
	@Input() side = '';
	@Input() data: Array<any> = [];
	@Output() dataChange = new EventEmitter();
	private readonly multipliers = {
		osobowy: [1.1, 1.25, 1.35],
		bus: [1.1, 1.25, 1.35],
		autokar: [1.25, 1.32, 1.5],
	};
	protected displayedColumns: string[] = ['vehicle', 'city', 'fee', 'stopTime', 'datetime', 'traffic'];

	constructor(
		private readonly infobox: InfoboxService,
		private readonly date: DateService,
		protected dialog: MatDialog,
	) {}

	hourChanged(currentTransport, previousTransport = null): void {
		if (currentTransport.country != '35') {
			// calculate only in Poland
			return;
		}
		if (!currentTransport.date || !currentTransport.time) {
			return;
		}
		// set time for other transports started with the same city
		let transports = this.data.filter(
			(obj) => obj.city == currentTransport.city && obj != currentTransport && obj != previousTransport,
		);
		transports.forEach((transport) => {
			if (transport.date == currentTransport.date && transport.time == currentTransport.time) {
				return;
			}
			transport.date = currentTransport.date;
			transport.time = currentTransport.time;
			this.hourChanged(transport, currentTransport);
		});
		// set hours for previous cities in same vehicle
		const currentItemIndex = this.data.findIndex((obj) => obj == currentTransport);
		transports = this.data
			.filter(
				(obj, index) =>
					obj.vehicle == currentTransport.vehicle && obj.country == '35' && index <= currentItemIndex,
			)
			.reverse();
		transports.forEach((transport, index) => {
			if (transport == currentTransport) {
				// skip current city
				return;
			}
			this.setHourForTransport(transport, transports[index - 1]);
			this.hourChanged(transport, currentTransport);
		});
	}

	private setHourForTransport(currentTransport, previousTransport): void {
		let minutes = this.minutesBetweenTransports(currentTransport.city, previousTransport.city);
		minutes *= this.multipliers[previousTransport.vehicleType][previousTransport.traffic];
		minutes = Math.floor(minutes);
		minutes += parseInt(previousTransport.stopTime);
		if (this.side == 'departure') {
			minutes = 0 - minutes;
		}
		const date = this.date.minutesAdd(minutes, previousTransport.date + ' ' + previousTransport.time);
		currentTransport.date = date.date;
		currentTransport.time = this.roundMinutes(date.time.slice(0, -3));
	}

	private minutesBetweenTransports(city1: number, city2: number): number {
		const pos = this.citiesConnections.find(
			(pos) => (pos.from == city1 && pos.to == city2) || (pos.from == city2 && pos.to == city1),
		);
		if (!pos) {
			const city1Name: string = this.data.find((obj) => obj.city == city1)?.cityName;
			const city2Name: string = this.data.find((obj) => obj.city == city2)?.cityName;
			this.infobox.error(
				'W systemie nie ma czasu przejazdu między: ' +
					city1Name +
					' a ' +
					city2Name +
					' Dział IT będzie tworzyć możliwość ręcznego wprowadzania połączeń. W przyszłośći połączenie z GoogleMaps',
			);
			// this.openMapDialog(city1, city2, city1Name, city2Name);
			return;
		}
		return parseInt(pos.minutes);
	}

	openMapDialog(city1, city2, city1Name, city2Name) {
		this.dialog.open(MapDialogComponent, {
			data: {
				city1,
				city2,
				city1Name,
				city2Name,
			},
		});
	}
	private roundMinutes(fullMinutes: string): string {
		let lastDigit: number = parseInt(fullMinutes.toString().slice(-1));
		const restDigits: string = fullMinutes.toString().slice(0, -1);
		if (lastDigit > 5) {
			lastDigit = 5;
		} else if (lastDigit > 0 && lastDigit < 5) {
			lastDigit = 0;
		}
		return restDigits.toString() + lastDigit.toString();
	}
}
